import { Stack, Link, Typography } from "@mui/material";
import { motion } from "motion/react";
import {
  PitSubCategory,
  SectionHeader,
  SectionHeaderHighlight,
  textStyles,
} from "@src/helpers/taxonomy";

import React, { FC } from "react";
import GlassContainer from "./GlassContainer";
import MarkdownWrapper from "../Markdown/MarkdownWrapper";

interface Props {
  category: PitSubCategory;
}

const Subcategory: FC<Props> = ({ category }) => {
  return (
    <>
      <motion.div
        initial={{
          opacity: 0,
          translate: "0px -20px",
          transform: `scale3d(1, 1, 1)`,
        }}
        transition={{
          delay: 0.06,
        }}
        whileInView={{
          opacity: 1,
          translate: "0px 0px",
        }}
        whileHover={{
          transform: `scale3d(1.01, 1.01, 1)`,
        }}
      >
        <Link
          role="button"
          href={`#${category.categoryId}`}
          sx={{
            ":hover": {
              cursor: "pointer",
            },
          }}
        >
          <GlassContainer>
            <Stack>
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <SectionHeaderHighlight>{category.name}</SectionHeaderHighlight>
                <SectionHeader>SUBCATEGORY</SectionHeader>
              </Stack>

              <Typography
                variant="body2"
                sx={{
                  ...textStyles,
                  "&:first-letter": {
                    textTransform: "capitalize",
                  },
                }}
              >
                <MarkdownWrapper content={category.description} />
              </Typography>
            </Stack>
          </GlassContainer>
        </Link>
      </motion.div>
    </>
  );
};

export default Subcategory;
